import filterMenuReducer from "./Reducer/filterMenu";
import bookReducer from "./Reducer/Books";
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'

const rootReducer = combineReducers({
  filterMenu: filterMenuReducer,
  book: bookReducer
});
const persitConfig = {    
  key : 'root',
  storage,
}


export default persistReducer(persitConfig, rootReducer);
